import { cn } from "@omni/utils/styles";
import { Ref } from "react";

type StoreDirectionsMapComponentProps = {
    ref?: Ref<HTMLDivElement>;
};

const StoreDirectionsMapComponent = ({
    ref
}: StoreDirectionsMapComponentProps) => {
    return (
        <div className={cn("tw:rounded-md tw:overflow-hidden tw:h-full")}>
            <div
                className={cn("tw:h-full")}
                ref={ref}
            />
        </div>
    );
};

export { StoreDirectionsMapComponent };
